// extracted by mini-css-extract-plugin
export default {"notification":"vNj_ih","newBoardName":"LJNbfd"};